import React, { memo } from 'react';
import { withStyles } from '@material-ui/core';
import { EMBARGO_MODES } from '../constants';
import { getPickupManagementTopEmbargoItems } from '../viewModel';
import { EmbargoSaveErrorBanner } from './EmbargoSaveErrorBanner';
import { EmbargoShipmentErrors } from './EmbargoShipmentErrors';
import type { EmbargoMode, EmbargoSaveError, EmbargoViolation } from '../types';

const styles = {
  container: {
    padding: '0 24px',
    boxSizing: 'border-box' as const,
  },
};

type EmbargoPickupManagementBannersProps = {
  classes: Record<string, string>;
  saveError: EmbargoSaveError | null;
  violations: EmbargoViolation[];
  warnings: EmbargoViolation[];
  mode?: EmbargoMode;
};

const EmbargoPickupManagementBannersComponent = ({
  classes,
  saveError,
  violations,
  warnings,
  mode = EMBARGO_MODES.CREATE,
}: EmbargoPickupManagementBannersProps) => {
  const topEmbargoItems = getPickupManagementTopEmbargoItems({ violations, warnings });
  const hasClientEmbargo =
    topEmbargoItems.violations.length > 0 || topEmbargoItems.warnings.length > 0;

  if (!saveError && !hasClientEmbargo) {
    return null;
  }

  return (
    <div className={classes.container}>
      <EmbargoSaveErrorBanner saveError={saveError} />
      {hasClientEmbargo && (
        <EmbargoShipmentErrors
          violations={topEmbargoItems.violations}
          warnings={topEmbargoItems.warnings}
          mode={mode}
        />
      )}
    </div>
  );
};

export const EmbargoPickupManagementBanners = withStyles(styles)(
  memo(EmbargoPickupManagementBannersComponent)
);
